import { render, staticRenderFns } from "./Chip.vue?vue&type=template&id=2a144640&scoped=true"
import script from "./Chip.vue?vue&type=script&lang=ts"
export * from "./Chip.vue?vue&type=script&lang=ts"
import style0 from "./Chip.scss?vue&type=style&index=0&id=2a144640&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a144640",
  null
  
)

export default component.exports